import { createAction } from '@reduxjs/toolkit';
import { TModerationUser, User } from './../types';

export const fetchUsersStart = createAction<{ type: TModerationUser }>(
  'MODERATION/USERS/FETCH_USERS_START'
);
export const fetchUsersSuccess = createAction<{
  users: any[];
  type: TModerationUser;
  count?: number;
  offset?: number;
  totalItems?: number;
}>('MODERATION/USERS/FETCH_USERS_SUCCESS');
export const fetchUsersFailure = createAction<{ type: TModerationUser }>(
  'MODERATION/USERS/FETCH_USER_FAILURE'
);

export const addUsersStart = createAction('MODERATION/USERS/ADD_USERS_START');
export const addUserSuccess = createAction<{
  type?: TModerationUser;
  user: User;
  ip?: string;
  userId?: string;
  usersFromIp?: string[];
}>('MODERATION/USERS/ADD_USERS_SUCCESS');
export const addUserFailure = createAction('MODERATION/USERS/ADD_USERS_FAILURE');

export const removeUsersStart = createAction('MODERATION/USERS/REMOVE_USERS_START');
export const removeUserSuccess = createAction<{
  type: TModerationUser;
  user: User;
  userId?: string;
  ip: string;
}>('MODERATION/USERS/REMOVE_USERS_SUCCESS');
export const removeUserFailure = createAction('MODERATION/USERS/REMOVE_USERS_FAILURE');
